import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Urls } from "../../shared/urls";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

declare var $;

@Component({
  standalone: false,
  selector: "app-ok-sign-success",
  templateUrl: "./ok-sign-success.component.html",
  styleUrls: ["./ok-sign-success.component.scss"]
})
export class OkSignSuccessComponent implements OnInit {
  logo;
  language;
  isError = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  async ngOnInit() {
    let fields = this.route.snapshot.queryParams.source_doc;
    fields = decodeURIComponent(fields);
    if (fields) {
      try {
        this.isError = this.route.snapshot.queryParams.status === "FAILED";

        const res: any = await this.getLogoAndLanguage(fields);
        this.logo = res.logo;
        this.language = res.language ? res.language : "english";
        switch (res.language) {
          case "english":
            this.translateService.use("english");
            break;
          case "french":
            this.translateService.use("french");
            break;
          case "dutch":
            this.translateService.use("dutch");
            break;
          case "german":
            this.translateService.use("german");
            break;
          default:
            this.translateService.use("english");
            break;
        }
      } catch (e) {
        this.language = "english";
        this.isError = true;
        this.translateService.setDefaultLang(this.language);
        console.error(":::OkSignSuccessComponent:::ngOnInit:::error:::", e);
      }
    } else {
      this.isError = true;
      this.translateService.use("dutch");
    }

    // remove loader
    $("#initial_loader").remove();
  }

  getLogoAndLanguage(fields) {
    return new Promise((resolve, reject) => {
      this.http.get(`${Urls.ESigning}retrieveDetails?sourceDoc=${fields}`).subscribe(
        (res: any) => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}
